const transition = 'transition-all duration-300';
const openedTransition = 'transform opacity-0';
const closedTransition = 'transform opacity-100';

export const toastTransformAnimations = {
  enter: transition,
  enterFrom: openedTransition,
  enterTo: closedTransition,
  leave: transition,
  leaveFrom: closedTransition,
  leaveTo: openedTransition,
};

export const placeholderTransformAnimations = {
  leave: 'transition-all duration-300 delay-600',
  leaveFrom: 'transform h-16',
  leaveTo: 'transform h-0',
};

export const TOAST_TTL = 6000;
